module.exports = __webpack_public_path__ + "static/media/property-managers-10.5db2f744.svg";